import React from "react";

/**
 * Ambient luminous blue glow — cinematic backdrop element.
 * Place absolutely positioned inside any relative parent.
 */
export const AmbientLight = ({
  size = 600,
  color = "blue",
  className = "",
  style = {},
  intensity = 1,
}) => {
  const colorMap = {
    blue: "rgba(0, 119, 255,",
    'blue-soft': "rgba(0, 170, 255,",
    gold: "rgba(198, 168, 107,",
    deep: "rgba(0, 13, 61,",
  };
  const base = colorMap[color] || colorMap.blue;
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute rounded-full ${className}`}
      style={{
        width: size,
        height: size,
        background: `radial-gradient(circle, ${base} ${0.4 * intensity}) 0%, ${base} ${0.18 * intensity}) 30%, transparent 70%)`,
        filter: `blur(${size * 0.12}px)`,
        ...style,
      }}
    />
  );
};

/**
 * Light Streak — a soft diagonal lighting line for cinematic moments.
 */
export const LightStreak = ({ className = "", angle = 135 }) => (
  <div
    aria-hidden="true"
    className={`pointer-events-none absolute ${className}`}
    style={{
      background: `linear-gradient(${angle}deg, transparent 0%, rgba(0,170,255,0.08) 40%, rgba(255,255,255,0.15) 50%, rgba(0,170,255,0.08) 60%, transparent 100%)`,
      filter: "blur(40px)",
    }}
  />
);

export default AmbientLight;
